export const getElementorOffset = (viewSize: number) => {
    if (viewSize >= 1728) return 144;
    if (viewSize >= 1440) return 80;
    if (viewSize >= 1280) return 64;
    if (viewSize >= 1025) return 48;

    return 24;
};